import { FC } from "react";
import { InformationBarProps } from "./information-bar.types";
import { InformationBar1 } from "./skins/information-bar-1";

const InformationBar: FC<InformationBarProps> = (props) => {
  return <InformationBar1 {...props} />;
};

export default InformationBar;
